import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const TableEssayGrades = ({descricaoCompetencia, className}) => {
  return (
    <div
      className={className}
      style={{ display: 'flex', justifyContent: 'center' }}
    >
      <TableContainer className="table-container">
            <Table>
              <TableHead className="tableHeader">
                <TableRow>
                  <TableCell className="text-header" align="center">
                    Pontuação
                  </TableCell>
                  <TableCell className="text-header" align="center">
                    Resultado
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {descricaoCompetencia && descricaoCompetencia.intervalos.map((intervalo, index) => (
                  <TableRow>
                    <TableCell
                      className="left-cell data-cell"
                      style={{
                        backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                      }}
                    >
                      {intervalo.pontuacao}
                    </TableCell>
                    <TableCell
                      align="center"
                      className="data-cell"
                      style={{
                        backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                      }}
                    >
                      {intervalo.descricao}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
    </div>
  );
};

export default styled(TableEssayGrades)`
  display: flex;
  align-items: center;
  justify-content: center;

  .table-container {
    width: 100%;
  }

  .tableHeader {
    color: #fff;
    font-size: 1.5rem;
    border-left: 1px solid #000; 
  }

  .text-header {
    border: 1px solid gray;
    color: white;
    background-color: ${props => props.theme.primary};
  }
`;
